import { createContext } from "react";

import { IContextStickers } from "./stickers.types";

export const ContextStickers = createContext<IContextStickers>(
  null as unknown as IContextStickers,
);
